import type { App, InjectionKey, DefineComponent } from 'vue';
import { repositoryInjectionKey, type NamedRepository } from '../repositories';

export function getPartialRepository(
    app: App,
    injectionKey?: InjectionKey<NamedRepository> | symbol | string
): NamedRepository {
    return app._context.provides[
        (injectionKey ?? repositoryInjectionKey) as symbol | string
    ];
}

export function registerPartial(
    app: App,
    name: string,
    loader: () => Promise<unknown>,
    injectionKey?: InjectionKey<NamedRepository> | symbol | string
) {
    getPartialRepository(app, injectionKey)?.registerPartial(
        name,
        loader as () => Promise<DefineComponent>
    );
}

export function registerPartials(
    app: App,
    partials: Record<string, () => Promise<unknown>>,
    prefix = '',
    injectionKey?: InjectionKey<NamedRepository> | symbol | string
) {
    const repository = getPartialRepository(app, injectionKey);
    if (repository) {
        Object.entries(partials).forEach(([k, v]) => {
            repository.registerPartial(
                prefix + k,
                v as () => Promise<DefineComponent>
            );
        });
    }
}
